<template>
    <div :class="selectedEventId == item.id ? 'scale-105 border-primary' : 'scale-100'" class="w-full p-6 sm:p-8 bg-white border shadow-lg flex justify-start items-start flex-wrap sm:flex-nowrap lg:flex-wrap xl:flex-nowrap transition-all duration-700">
        <img v-if="hasThumbnail" class="flex-shrinik-0 w-full sm:w-48 mr-8 object-contain" :src="getImage" alt="thumbnail">
        <div class="flex-grow flex flex-col mt-4 sm:mt-0 lg:mt-6 xl:mt-0">
            <h1 class="font-medium text-base sm:text-lg">{{ item.title }}</h1>
            <div class="flex items-center mt-2">
                <font-awesome-icon icon="fa-solid fa-calendar-days" class="text-primary mr-2" />
                <div class="text-xs">{{ getEventDatetime }}</div>
            </div>
            <div v-if="item.location" class="flex items-center mt-2">
                <font-awesome-icon  :icon="['fas', 'location-dot']" class="text-primary mr-2" />
                <div class="text-xs">{{ item.location }}</div>
            </div>
            <p class="text-xs sm:text-sm font-light truncate-3 mt-4">{{ item.description }}</p>
            <div class="flex justify-end mt-4">
                <router-link :to="`/events/${item.slug}`" class="w-full sm:w-auto flex justify-center items-center cursor-pointer border border-primary text-white hover:text-primary view-all bg-primary hover:bg-white transition-all duration-200 px-4 py-2">
                    <div class="leading-none mr-1 text">View event</div>
                    <icon-right-arrow class="w-5 h-5 icon transition-all duration-200 ease-bounce"></icon-right-arrow>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import IconRightArrow from "../../components/icons/IconRightArrow.vue";
import { converToIsoTimestamp } from "../../helpers/utils.js";
export default {
    name: "event-calendar-card",
    props: ["item", "selectedEventId"],
    components: {
        IconRightArrow,
    },
    computed: {
        hasThumbnail() {
            if (this.item.thumbnail) {
                return true;
            } else {
                return false;
            }
        },
        getImage() {
            return process.env.VUE_APP_PUBLIC_URL + this.item.thumbnail;
        },
        getEventDatetime() {

            const startDate = new Date(converToIsoTimestamp(this.item.start_date));
            const endDate = new Date(converToIsoTimestamp(this.item.end_date));

            let startStr;
            let endStr;
            if (this.item.display_time) {
                startStr = startDate.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true });
                endStr = endDate.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true });
            } else {
                if (this.item.display_day) {
                    startStr = startDate.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
                    endStr = endDate.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
                } else {
                    startStr = startDate.toLocaleString('en-US', { month: 'short', year: 'numeric' });
                    endStr = endDate.toLocaleString('en-US', { month: 'short', year: 'numeric' });
                }
            }

            let formattedDate = "";
            if (startStr != endStr) {
                formattedDate += `${startStr} - ${endStr}`;
            } else {
                formattedDate += `${startStr}`;
            }

            return formattedDate;
        },
    },
}
</script>

<style lang="scss" scoped>
.truncate-3 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
.scale-100 {
    scale: 1;
}
.scale-105 {
    scale: 1.05;
}
.view-all {
  &:hover {
    .text {
      font-weight: 600;
    }
    .icon {
      transform: translateX(0.25rem);
    }
  }
}
.ease-bounce {
    transition-timing-function: cubic-bezier(0.34, 1.61, 0.7, 1.3);
}
</style>